import React from "react";
import styles from "../../assets/css/modules/onboarding/member-details.css";

const MemberDetailsValidationMessages = ({
  validationMessages,
  multiMessageHeading,
  mfa
}) => {
  if (Array.isArray(validationMessages) && validationMessages.length > 0) {
    let isSingleMessage = validationMessages.length === 1;

    return (
      <div id="validationmessages" className={"alert alert-danger "+ (mfa === true ?styles.danger:" ")}  role="alert">
        {isSingleMessage ? (
          <div id="singleMessage" className="mb-0">
            {validationMessages[0]}
          </div>
        ) : (
          <div id="multipleMessages">
            <p className="alert-heading mb-1">
              <strong>{multiMessageHeading}</strong>
            </p>
            <ul className="mb-0 pl-4">
              {validationMessages.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default MemberDetailsValidationMessages;
